import { styled, Theme } from "@mui/material";
import { SxProps } from "@mui/system/styleFunctionSx";

import iCoppLogoSvg from "assets/icopp-logo.svg";

const StyledImg = styled("img")({
    height: 40,
});

export interface ICoppLogoProps {
    sx?: SxProps<Theme>;
}

export default function ICoppLogo(props: ICoppLogoProps) {
    return (
        <StyledImg
            src={iCoppLogoSvg}
            sx={[...(Array.isArray(props.sx) ? props.sx : [props.sx])]}
        />
    );
}
